import { useIsMobile } from "@/hooks/use-mobile";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const usePropertyBulkUpload = () => {
  const navigate = useNavigate();
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const [currentStep, setCurrentStep] = useState<number>(1);
  const isMobile = useIsMobile();

  const breadcrumbData = [
    {
      link: ``,
      name: `Master Data`,
    },
    {
      link: ``,
      name: `Property Config`,
    },
    {
      link: `/${routes.admin}/${routes.masterData}/${routes.properties}`,
      name: `Manage Property - ${communityData?.name}`,
    },
    {
      link: "",
      name: <span className="text-primary">{"Bulk Upload Properties"}</span>,
    },
  ];

  const onNextStepClick = () => {
    setCurrentStep(currentStep + 1);
  };

  const onPreviousStepClick = () => {
    setCurrentStep(currentStep - 1);
  };

  const onStepperClick = (curr_step: number) => {
    setCurrentStep(curr_step);
  };

  const onBackClick = () => {
    navigate(`/${routes.admin}/${routes.masterData}/${routes.properties}`)
  }

  return {
    breadcrumbData,
    isMobile,
    currentStep,
    onStepperClick,
    onNextStepClick,
    onPreviousStepClick,
    onBackClick
  }
}

export default usePropertyBulkUpload;